module.exports = __webpack_public_path__ + "img/loading-balls.22951902.svg";